import React from 'react'
import styled from 'styled-components'

const Copy = styled.div`
    text-align: center;
    p {
        line-height: 1.2;
        margin-top: 0;
        font-size: 1.666rem;
        margin-bottom: 3rem;
        &.small-for-device {
            font-size: 1.2rem;
            max-width: 700px;
            line-height: 1.3;
            margin-left: auto;
            margin-right: auto;
        }
    }
    @media all and (max-width: 767px) {
        p {
            font-size: 1.3333rem;
            &.small-for-device {
                font-size: 1rem;
            }
        }
    }
`

const CopyRow = ({copy}) => {
    return (
        <Copy className="contain contain-tight contain-copy-row row-component">
            <div dangerouslySetInnerHTML={{__html: copy}} />   
        </Copy>
    )
}

export default CopyRow

